import { ModeratorInfo, SubmittedModeratedCentre } from '@cambridgeassessment/lib-ee-commons';
import { PostResultsParams } from '../../types/PostResults';
import { get, patch, post } from '../httpHelpers/papiEntree';

export const getSubmittedModeratedCentre = async (
  queryParams: PostResultsParams,
): Promise<SubmittedModeratedCentre> => {
  const url = [
    'v1',
    `businessUnit/${queryParams.businessUnitId}`,
    `series/${queryParams.seriesId}`,
    `centres/${queryParams.centreId}`,
    `qualifications/${queryParams.qualificationId}`,
    `assessments/${queryParams.assessmentCode}`,
    `components/${queryParams.componentNumber}`,
    'centres-with-moderated-samples',
  ].join('/');

  return get(url);
};

export const setPostResultsReviewModerator = async (
  queryParams: PostResultsParams,
  creditorNumber: number,
): Promise<void> => {
  const url = [
    'v1',
    `businessUnit/${queryParams.businessUnitId}`,
    `series/${queryParams.seriesId}`,
    `centres/${queryParams.centreId}`,
    `qualifications/${queryParams.qualificationId}`,
    `assessments/${queryParams.assessmentCode}`,
    `components/${queryParams.componentNumber}`,
    'post-results-review',
  ].join('/');
  post(url, { creditorNumber });
};

export const unallocatePostResultModerator = async (
  queryParams: PostResultsParams,
  creditorNumber: number,
): Promise<void> => {
  const url = [
    'v1',
    `businessUnit/${queryParams.businessUnitId}`,
    `series/${queryParams.seriesId}`,
    `centres/${queryParams.centreId}`,
    `qualifications/${queryParams.qualificationId}`,
    `assessments/${queryParams.assessmentCode}`,
    `components/${queryParams.componentNumber}`,
    'remove-post-results-moderator',
  ].join('/');
  patch(url, { creditorNumber });
};

export const getAvailableModerators = async (queryParams: PostResultsParams): Promise<ModeratorInfo[]> => {
  const url = [
    'v1',
    `businessUnit/${queryParams.businessUnitId}`,
    'panels',
    `series/${queryParams.seriesId}`,
    `centres/${queryParams.centreId}`,
    `assessments/${queryParams.assessmentCode}`,
    `components/${queryParams.componentNumber}`,
    'available-post-results-moderators',
  ].join('/');

  return get(url);
};
